if (!window.customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();

      const checkbox = this.querySelector('input[type="checkbox"]');

      if (!checkbox) {
        return;
      }

      // Capture-phase listener on document is guaranteed to run before the form's own
      // submit listeners — notably custom-button's, which flips the checkout button into
      // its aria-busy loading state on any submit and only resets it on pageshow.
      // Stopping propagation of a cancelled submit keeps that state from ever engaging.
      //
      // checkbox.form is resolved per event, not at bind time, so the gate holds even if
      // the checkbox-to-form association (form="" attribute) is established after this
      // element upgrades, e.g. during the cart drawer's footer re-render.
      document.addEventListener('submit', (event) => {
        if (event.target !== checkbox.form || checkbox.checked) {
          return;
        }

        // Resolve the message before preventDefault so a missing string can never
        // abort the handler after the submission has already been cancelled
        const message = window.themeVariables?.strings?.cartTermsConfirmation
          || 'You must agree to the terms and conditions before continuing.';

        event.preventDefault();
        event.stopPropagation();
        alert(message);
      }, { capture: true, signal: this._abortController.signal });
    }

    disconnectedCallback() {
      this._abortController.abort();
    }
  }

  window.customElements.define('cart-terms', CartTerms);
}
